// RealTimeViewer.tsx

import { getRealTimeData } from "@/pages/caster/repositories/ProductionRepository";
import { ErrorModal, useShiftNavigator } from "@dexteel/mesf-core";
import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import React, { useState, useEffect } from "react";

export interface RealTimeData {
	ShiftId: number;
	CASTonsPerHour: number;
	CASTons: number;
}

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		card: {
			width: 250,
			height: 80,
		},
		row: {
			marginBottom: theme.spacing(1),
		},
		label: {
			fontWeight: "bold",
			userSelect: "none",
		},
		value: {},
	}),
);

const RealTimeViewer: React.FC = () => {
	const classes = useStyles();

	const [error, setError] = useState<string>("");
	const { shiftInfo } = useShiftNavigator();

	const [realTimeData, setRealTimeData] = useState<RealTimeData | null>(null);

	const fetchRealTimeData = async () => {
		if (shiftInfo) {
			const resp = await getRealTimeData(shiftInfo.CurrentShiftId);
			if (resp.ok) {
				setRealTimeData(resp.data.tables[0].rows[0]);
			} else {
				setError(resp.message);
			}
		}
	};

	useEffect(() => {
		if (!shiftInfo) return;
		fetchRealTimeData();

		let intervalId: NodeJS.Timeout | undefined;
		if (shiftInfo.CurrentShiftId === shiftInfo.LastShiftId) {
			intervalId = setInterval(() => {
				fetchRealTimeData();
			}, 120000); // 2 minutes
		}

		return () => {
			if (intervalId) clearInterval(intervalId);
		};
	}, [shiftInfo]);

	return (
		<>
			<Card className={classes.card} elevation={1}>
				<CardContent>
					<Grid container direction="column">
						<Grid
							item
							container
							justify="space-between"
							className={classes.row}
						>
							<Typography className={classes.label}>Cast Tons/hour</Typography>
							<Typography className={classes.value}>
								{realTimeData ? realTimeData.CASTonsPerHour?.toFixed(2) : "-"}
							</Typography>
						</Grid>
						<Grid
							item
							container
							justify="space-between"
							className={classes.row}
						>
							<Typography className={classes.label}>Cast Tons</Typography>
							<Typography className={classes.value}>
								{realTimeData ? realTimeData.CASTons?.toFixed(2) : "-"}
							</Typography>
						</Grid>
					</Grid>
				</CardContent>
			</Card>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};

export default RealTimeViewer;
